import { type WorkspaceAgentMentionRowItem } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/types';
import {
  getFirstWorkspaceAgentMentionableIndex,
  getFirstWorkspaceAgentMentionHitIndex,
} from '~/components/v2/components/workspace/workspace-agent-panel/mentions/workspaceAgentMentionItems';

const highlightIndexForQuery = (items: readonly WorkspaceAgentMentionRowItem[], query: string) =>
  query === '' ? getFirstWorkspaceAgentMentionableIndex(items) : getFirstWorkspaceAgentMentionHitIndex(items);

export type ResolveWorkspaceAgentSelectAssetHighlightIndexParams = {
  nextItems: readonly WorkspaceAgentMentionRowItem[];
  previousIndex: number;
  previousItems: readonly WorkspaceAgentMentionRowItem[];
  query: string;
};

/**
 * Pagination, tree expansion, and a same-query snapshot keep every previous row and should keep the
 * highlight on that row. A replaced list (a new query) falls back to the first mentionable or hit.
 */
export const resolveWorkspaceAgentSelectAssetHighlightIndex = ({
  nextItems,
  previousIndex,
  previousItems,
  query,
}: ResolveWorkspaceAgentSelectAssetHighlightIndexParams) => {
  const previousItem = previousItems[previousIndex];
  const keepsPreviousRows =
    previousItems.length > 0 && previousItems.every((item) => nextItems.some((nextItem) => nextItem.id === item.id));

  if (keepsPreviousRows && previousItem) {
    const preservedIndex = nextItems.findIndex((item) => item.id === previousItem.id);

    if (preservedIndex >= 0) {
      return preservedIndex;
    }
  }

  return highlightIndexForQuery(nextItems, query);
};
